import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import SiteFooter from '../components/SiteFooter';
import { useCart } from '../context/CartContext';
import { useLanguage } from '../context/LanguageContext';
import './ShopList.css';

const Cart = () => {
  const { items, removeFromCart } = useCart();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const total = items.reduce((sum, p) => sum + (p.price || 0), 0);

  return (
    <div className="home-page">
      <Header />
      <div className="shoplist-page">
        <h1 className="shoplist-title">{t('shoplist.cartTitle')}</h1>

        {items.length === 0 ? (
          <div className="shoplist-empty">
            <p>{t('shoplist.cartEmpty')}</p>
            <Link to="/photobooks" className="shoplist-empty-btn">{t('shoplist.viewProducts')}</Link>
          </div>
        ) : (
          <>
            <div className="shoplist-items">
              {items.map((item) => (
                <div key={item.id} className="shoplist-item">
                  <div className="shoplist-item-image">
                    {item.image && <img src={item.image} alt={item.name} />}
                  </div>
                  <div className="shoplist-item-info">
                    <p className="shoplist-item-name">{item.name}</p>
                    <p className="shoplist-item-price">€{item.price?.toFixed(2)}</p>
                  </div>
                  <div className="shoplist-item-actions">
                    <button className="shoplist-continue-btn" onClick={() => navigate(`/product/${item.id}`)}>
                      {t('shoplist.continueOrder')}
                    </button>
                    <button className="shoplist-remove-btn" onClick={() => removeFromCart(item.id)}>
                      {t('shoplist.remove')}
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="shoplist-total">
              <span>{t('shoplist.total')}</span>
              <strong>€{total.toFixed(2)}</strong>
            </div>
          </>
        )}
      </div>
      <SiteFooter />
    </div>
  );
};

export default Cart;
